var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 1.75,
    width: 16.5,
    height: 20.5,
    rx: 1.75,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 8,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 8,
    height: 4,
    rx: 1,
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 10.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 5.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 5.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 10.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineIcon);
export default __webpack_public_path__ + "static/media/machine-icon.fece6f4afd7466adfe690c27f34921ac.svg";
export { ForwardRef as ReactComponent };